import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

type EntityType = 'data' | 'block' | 'flow' | 'imageRegistry' | 'project'

@Injectable({
    providedIn: 'root'
})
export class CheckExistsService {

    private apiUrl = `${ environment.serverUrl }/api/check-exists`;

    constructor(private http: HttpClient) { }

    checkExists(
        entity: EntityType,
        name: string,
        excludeId?: string,
        projectId?: string
    ): Observable<{ exists: boolean }> {
        const params: any = { name };
        if (excludeId) params.excludeId = excludeId;
        if (projectId) params.project_id = projectId;

        return this.http.get<{ exists: boolean }>(
            `${ this.apiUrl }/${ entity }`,
            { params }
        );
  }
}
